import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import BookingFormRow from '../features/register-booking/ui/BookingFormRow';
import { fetchCounterPoints, fetchRoomTypes } from '../features/register-booking/api/registerBookingApi';
import { getCurrentLanguageKey, getLanguageSection } from '../shared/services/languageService';

function RegisterBooking() {
  const [rows, setRows] = useState(1);
  const [pointsAvailable, setPointsAvailable] = useState(0);
  const [pointsPending, setPointsPending] = useState(0);
  const [roomTypes, setRoomTypes] = useState([]);

  const language = getLanguageSection('registerbooking');
  const countryUser = Cookies.get('CountryUser');

  useEffect(() => {
    fetchCounterPoints({
      userAccessToken: Cookies.get('UserAccessToken'),
      deviceAccessToken: Cookies.get('DeviceAccessToken')
    })
      .then(({ pointsAvailable: available, pointsPending: pending }) => {
        setPointsAvailable(available);
        setPointsPending(pending);
      })
      .catch(() => {});

    fetchRoomTypes(getCurrentLanguageKey())
      .then((data) => setRoomTypes(data))
      .catch(() => setRoomTypes([]));
  }, []);

  const addAnotherRow = () => setRows((currentRows) => currentRows + 1);
  const removeRow = () => setRows((currentRows) => (currentRows === 1 ? currentRows : currentRows - 1));

  const bookingForms = [];
  for (let i = 1; i <= rows; i++) {
    bookingForms.push(<BookingFormRow formItemNumber={i} key={i} index={i} roomTypes={roomTypes} />);
  }

  return (
    <div id="registerbooking" className="mr-ui bg-[#eef1f7] px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        {/* Bloque de puntos: solo para agentes de México (CountryUser === '167') */}
        {countryUser === '167' ? (
          <div className="grid gap-5 md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,2fr)]">
            <div className="flex min-h-[112px] items-center rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <h1 className="m-0 text-xl font-normal uppercase text-marival-navy">{language.text1}</h1>
            </div>
            <div className="flex min-h-[112px] items-center rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <div className="space-y-2">
                <h2 className="m-0 flex items-baseline gap-3 text-2xl font-normal text-marival-sky">
                  <span>{pointsPending}</span>
                  <small className="text-xs font-normal uppercase text-slate-500">{language.pending}</small>
                </h2>
                <h2 className="m-0 flex items-baseline gap-3 text-2xl font-normal text-marival-sky">
                  <span>{pointsAvailable}</span>
                  <small className="text-xs font-normal uppercase text-slate-500">{language.available}</small>
                </h2>
              </div>
            </div>
            <div className="flex min-h-[112px] items-center rounded-2xl bg-marival-coral p-7 text-white shadow-coral">
              <h3 className="m-0 max-w-2xl text-2xl font-semibold leading-tight">{language.text2}</h3>
            </div>
          </div>
        ) : null}

        <div className="mt-6">
          {bookingForms}
          <div className="mt-5 flex flex-wrap justify-end gap-3">
            {rows > 1 ?
              <button type="button" className="min-h-[44px] rounded-xl bg-marival-coral px-5 text-sm font-semibold text-white shadow-sm transition hover:bg-[#e0485c]" onClick={removeRow}>{language.lessrow}</button>
              : null}
            <button type="button" className="min-h-[44px] rounded-xl bg-marival-sky px-5 text-sm font-semibold text-white shadow-sm transition hover:bg-[#276cae]" onClick={addAnotherRow}>{language.addrow}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterBooking;
